import { render, staticRenderFns } from "./DialogoBurbuja.vue?vue&type=template&id=c08b2492&scoped=true&lang=pug&"
import script from "./DialogoBurbuja.vue?vue&type=script&lang=js&"
export * from "./DialogoBurbuja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b2492",
  null
  
)

export default component.exports